module.exports = __webpack_public_path__ + "static/media/rules_nogi.5b48e136.jpg";